import type { ButtonProps } from "@ecco/ui/button";
import { eccoClubVerticalGradient } from "@ecco/ui/tokens/colors";

const baseNavigationLinkStyles = (isActive: boolean): ButtonProps["sx"] => ({
    textDecoration: "none",
    _hover: isActive
        ? {
              textDecoration: "none",
              cursor: "default",
          }
        : {
              textDecoration: "none",
              color: "gray.900",
          },
    fontWeight: "bold",
    flexShrink: 0,
    backgroundColor: isActive ? "gray.800" : "white",
    color: isActive ? "white" : "black",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    h: 10,
    px: 3,
    py: 4,
    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.10)",
    fontSize: ["desktopBodyB2", "mobileBodyB2"],
    mb: 3,
});

export const pageNavigationLinkStyles = (isActive: boolean): ButtonProps["sx"] => ({
    ...baseNavigationLinkStyles(isActive),
    borderRadius: "full",
});

export const eccoClubLinkStyles = (isActive: boolean): ButtonProps["sx"] => ({
    ...baseNavigationLinkStyles(isActive),
    borderRadius: "none",
    borderLeft: "4px solid",
    borderImage: `${eccoClubVerticalGradient} 1`,
});

export const nondisplayedLink = (isActive: boolean): ButtonProps["sx"] => ({
    textDecoration: "none",
    _hover: isActive
        ? {
              textDecoration: "none",
              cursor: "default",
          }
        : {
              textDecoration: "none",
              color: "gray.900",
          },
    fontWeight: "semibold",
    minW: "24",
    flexShrink: 0,
    backgroundColor: isActive ? "black" : "unset",
    color: isActive ? "white" : "black",
    display: "none",
    justifyContent: "center",
    alignItems: "center",
    py: "2",
    px: "4",
    borderRadius: "full",
});
